import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableClientCreatePage = withAsyncLoading(async () =>
    import('./ClientCreatePage').then((res) => res.ClientCreatePage)
);

export { LoadableClientCreatePage };
